import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import AppDialog from '../../../shared/components/AppDialog';
import useResultSummary from '../hooks/useResultSummary';
import ResultSummaryTable from './ResultSummaryTable';

export default function ImportResultDialog({
  open,
  sourceId,
  sourceTitle,
  year,
  onClose,
  onExited,
}) {
  const { t } = useTranslation();
  const { data, loading, error, reload } = useResultSummary({
    sourceId,
    year,
    enabled: open,
  });

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      TransitionProps={{ onExited }}
      maxWidth="lg"
      fullWidth
      sx={{ '& .MuiButton-root': { borderRadius: '6px' } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        {t('dataInput.resultTable.title')}
        <IconButton
          onClick={onClose}
          aria-label={t('common.close')}
          sx={{ position: 'absolute', right: 12, top: 12 }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Stack direction="row" spacing={3}>
            <Stack spacing={0.25}>
              <Typography variant="caption" color="text.secondary">
                {t('dataInput.uploadConfirm.source')}
              </Typography>
              <Typography variant="body2" fontWeight={700} sx={{ minWidth: 160 }}>
                {sourceTitle}
              </Typography>
            </Stack>
            <Stack spacing={0.25}>
              <Typography variant="caption" color="text.secondary">
                {t('dataInput.reportingYear')}
              </Typography>
              <Typography variant="body2" fontWeight={700}>{year}</Typography>
            </Stack>
          </Stack>
          <ResultSummaryTable
            sourceId={sourceId}
            data={data}
            loading={loading}
            error={error}
            onRetry={reload}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
        <Button onClick={reload} disabled={loading}>
          {t('dataInput.resultTable.refresh')}
        </Button>
        <Button variant="contained" onClick={onClose}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </AppDialog>
  );
}